const apikey = {
    SERVICE:'service_l6tsdn7',
    USER_ID: '68OjB-xvXQmouXtq8',
    RESERVATION_TEMPLATE: 'template_xniit97'
}

export default apikey

